export default __webpack_public_path__ + "static/hdfclife-23a37c698b77ead507bea71991ee9f9b.png";